import styled, { ThemeProvider } from 'styled-components';
export var SVGThemeProvider = ThemeProvider;
export var SVGStyled = styled;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/svg/shared.js
// module id = 553
// module chunks = 12